// Feature flag configuration
//CASEMANAGEMENT_FLAG
const caseManagementFlag = "CASE_MANAGEMENT_FLAG";
export const isCaseManagementEnabled = caseManagementFlag === "true";
const caseManagementPhase3 = "CASE_MANAGEMENT_PHASE_3";
export const isCaseManagementPhase3Enabled = caseManagementPhase3 === "true";
const compareReportsFlag = "COMPARE_REPORTS_FLAG";
export const isCompareReportsEnabled = compareReportsFlag === "true";
